module.exports = {"lang":"zh-HK","lang_lib":"zh_TW","order_header_right_extra_option":{"name":"服務說明","link":"service","target":"_blank"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/general/setting.json
// module id = 553
// module chunks = 0 1 2 3 4 5